/**
 * DEGELER smart search: typo/synonym rewrite + empty-state helpers.
 * Hooks into Prestige <predictive-search> without forking theme.js.
 */
(function () {
  var MAP = [
    [/skayhanger|sky.?hanger|skihanger|skyhager/i, 'skyhanger'],
    [/kleidersac(?:k)?s?|kleider.?sack|garment.?bag|anzug.?sack/i, 'kleidersack'],
    [/anzugtsche|anzug.?tasche|suit.?bag|business.?bag/i, 'anzugtasche'],
    [/weeknder|week.?ender|weekender?/i, 'weekender'],
    [/ruksack|ruck.?sack|backpack/i, 'rucksack'],
    [/kulturtasche|kultur.?tasche|toiletry|waschbeutel/i, 'kulturtasche'],
    [/hemdentasche|hemd.?tasche|shirt.?bag/i, 'hemdentasche'],
    [/b[uü]gel|titan.?b[uü]gel|kleiderb[uü]gel/i, 'titanbügel'],
    [/leder.?edition|leather/i, 'leder'],
    [/luminous|leucht/i, 'luminous'],
    [/xl|uebergr[oö]sse|übergröße|mantel/i, 'xl']
  ];

  function rewrite(q) {
    if (!q || q.length < 2) return q;
    var out = q;
    for (var i = 0; i < MAP.length; i++) {
      if (MAP[i][0].test(out)) {
        out = out.replace(MAP[i][0], MAP[i][1]);
      }
    }
    return out;
  }

  function enhanceInput(input) {
    if (!input || input.dataset.degelerSmart === '1') return;
    input.dataset.degelerSmart = '1';
    var last = '';
    input.addEventListener('input', function () {
      var raw = input.value;
      var next = rewrite(raw);
      if (next !== raw && next !== last) {
        last = next;
        var start = input.selectionStart;
        input.value = next;
        try {
          input.setSelectionRange(start, start);
        } catch (e) {}
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  function scan() {
    document.querySelectorAll('input[type="search"][name="q"], .header-search__input, .main-search-form input[name="q"]').forEach(enhanceInput);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
